import React from "react";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import retiraMascaraTelefone from "./retiraMascaraTelefone";

const renderStoreInfo = (revenda) => {
  return (
    <>
      <li>
        <a href={revenda.mapa_link} target="_blank" rel="noopener noreferrer">
          {`${revenda.peendereco_fiscal}, ${revenda.pebairro_fiscal}, ${revenda.peendereco_fiscal_numero}, ${revenda.pecidade} - ${revenda.peuf}`}
        </a>
      </li>
      <li>
        <a href={`https://api.whatsapp.com/send?phone=55${retiraMascaraTelefone(revenda.petelefone2, "link")}`} target="_blank" rel="noopener noreferrer">
          <FaWhatsapp /> {retiraMascaraTelefone(revenda.petelefone2)}
        </a>
      </li>
      <li>
        <FaEnvelope /> <a href={`mailto:${revenda.peemail}`}>{revenda.peemail}</a>
      </li>
    </>
  );
};

export default renderStoreInfo;